import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import useRoomcode from '../hooks/useRoomcode';
import BubbleText from './BubbleText';

interface RoomcodeProps { }

const Roomcode: React.FC<RoomcodeProps> = () => {
  const roomcode = useRoomcode();
  return (
    <>
      <CopyToClipboard text={window.location.href}>
        <div data-tip='room link copied 👌' data-event='click focus' className='cursor-pointer'>
          <BubbleText text={roomcode} />
        </div>
      </CopyToClipboard>
      <ReactTooltip isCapture globalEventOff='click' effect='solid' type='dark' place='bottom' />
    </>
  );
}

export default Roomcode;
